import React from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";

import { useUsersContext } from "../contexts/Users";

import { selectUsers } from "../../../../features/user/userSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

const UserSelector = (): React.JSX.Element => {
    const users = useAppSelector(selectUsers);
    const { setUserId, setIsAddingUser } = useUsersContext();
    return (
        <Row>
            <Col xs={6} lg={4} xl={2}>
                <b>Select User:</b>
            </Col>
            <Col>
                <Select
                    isClearable={true}
                    isSearchable={true}
                    isMulti={false}
                    options={users.map(u => ({
                        value: u.id,
                        label: `${u.meta.firstName} ${u.meta.lastName} (${u.email})`,
                    }))}
                    onChange={v => {
                        if (v) {
                            setUserId(v?.value);
                            setIsAddingUser(false);
                        } else {
                            setUserId(undefined);
                        }
                    }}
                />
            </Col>
        </Row>
    );
};

export default UserSelector;
